import axios from 'axios'

const URL_PATH = 'api/comprasLegado/ata'

class ComprasLegadoApiClient {
	async buscarUrl({ idAtaRegistroPreco, idUnidadeOrganizacional }) {
		return await axios.get(`${URL_PATH}/url`, {
			headers: {
				idAtaRegistroPreco: idAtaRegistroPreco,
				idUnidadeOrganizacional: idUnidadeOrganizacional,
			},
		})
	}
}

export default new ComprasLegadoApiClient()
